import { Link, useLocation } from "react-router-dom";
import "./PageTitle.scss";
import { IoMdArrowBack } from "react-icons/io";
import { ReactComponent as Arrow } from "../../assets/arrow-left.svg";

export default function PageTitle({ title, link, previousBread, actualBread }) {
  const location = useLocation();
  // ex: "/my-sessions/myhote...."
  const path = location.pathname;

  // check se começa com "/my-sessions/" e tem algo depois
  const showBack = /^\/my-sessions\/.+/.test(path);

  return (
    <div className="page-title">
      <div className="container">
        <div className="container-flex">
          {showBack && (
            <Link to={link} className="icon">
              <Arrow />
            </Link>
          )}
          <h1>{title}</h1>
        </div>
        {showBack && (
          <div className="breadcrumbs">
            <ol className="list">
              <li className="breadcrumb-item">{previousBread}</li>
              <li>/</li>
              <li className="breadcrumb-item active">{actualBread}</li>
            </ol>
          </div>
        )}
      </div>
    </div>
  );
}
